import { DateTime } from 'luxon';
import { getIntl } from './intl';

const intl = getIntl('getAge', {
    lessThanOneYear: '< 1 year old',
});

export default function (dob: string | undefined | null): number | string | null {
    // @ts-expect-error TS2322
    if (!dob) return undefined;

    const currentDate = DateTime.now(); // current date

    const luxonDate = DateTime.fromISO(dob);
    if (!luxonDate.isValid) {
        return null;
    }

    const diffInYears = currentDate.diff(luxonDate, 'years');

    if (diffInYears.years < 1) {
        return intl('lessThanOneYear');
    }

    return Math.floor(diffInYears.years);
}
